import React from 'react'
import { Link } from 'react-router-dom'

function AboutOne() {
  return (
    <>
      {/* Inner Banner Section */}
      <section className="inner-banner">
        <div
          className="image-layer"
          style={{ backgroundImage: "url(assets/images/coimbatore-homemade-food-banner.jpg)" }}
        ></div>
        <div className="auto-container">
          <div className="inner">
            <h1>About Us</h1>
            <div className="sub_text">
              <p>
                Home - <a href="about" className="primary-color"> About us</a>
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Story Section */}
      <section className="story-section section-kt">
        <div className="auto-container">
          <div className="title-box centered">
            <div className="subtitle"><span>Tickling Tummy</span></div>
            <h2>
              About Tickling Tummy – <span className="theme_color">A Home That Cooks for You </span>
            </h2>
          </div>

          <div className="row clearfix">
            {/* AI Grounding Summary */}
            <div className="col-12 mb-4" style={{ paddingBottom: "20px" }}>
              <p style={{ fontSize: "1.2em", fontStyle: "italic", color: "var(--white-color)", lineHeight: "1.6em" }}>
                <strong>Tickling Tummy</strong> is a premier <strong>homemade vegetarian food service in Coimbatore</strong>, located in <strong>R.S. Puram</strong>. We specialize in healthy daily meal subscriptions, customized pre-order tiffin services, and gourmet event catering, serving the local community with fresh, hygienic, and authentic home-cooked meals.
              </p>
            </div>
            {/* Text Column */}
            <div className="text-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div className="inner wow fadeInLeft" data-wow-duration="1500ms" data-wow-delay="0ms">
                <div className="text">
                  We didn’t plan to start a food service. It began the way most good things do—quietly.
                  One day, we cooked a little extra and shared it with someone who needed a meal. Then another.
                  Then someone asked if we could make it again, maybe with less spice. Then someone else asked
                  if we’d pack lunch for their parents. And just like that, our home became a kitchen for more
                  than just our family.<br /><br />

                  <div className="text">
                    That’s how <span className="theme_color">Tickling Tummy</span> was born. We’re based in R.S. Puram,
                    Coimbatore, and everything we make is pure vegetarian, made fresh, and cooked the way we feed
                    ourselves. No artificial shortcuts. No bulk production. Just honest food from a small kitchen
                    that believes meals aren’t just about nutrition—they’re about comfort, care, and connection.
                  </div><br /><br />

                  <div className="text">
                    We don’t have a big team. No chefs in hats. Just a handful of real people who wake up early,
                    grind chutneys by hand, steam rice properly, and taste everything before it goes into a dabba.
                  </div>
                </div>
              </div>
            </div>

            {/* Image Column */}
            <div className="image-col col-xl-6 col-lg-6 col-md-12 col-sm-12">
              <div className="inner wow fadeInRight" data-wow-duration="1500ms" data-wow-delay="0ms">
                <div className="images parallax-scene-1">
                  <div className="image" data-depth="0.15">
                    <img src="assets/images/about-tickling-tummy-kitchen.jpg" alt="office lunch delivery Coimbatore" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Intro / Team Section */}
      <section className="intro-section why-us-two">
        <div className="intro-anim-image">
          <img src="assets/images/about-tickling-tummy-dish.png" alt="lunch box service Coimbatore" />
        </div>
        <div className="auto-container">
          <div className="title-box centered">
            <div className="subtitle"><span>our team</span></div>
            <h2>The Family Behind Tickling Tummy</h2>
          </div>

          <div className="row justify-content-center clearfix">
            {/* Team Member */}
            <div className="team-block col-lg-4 col-md-6 col-sm-6 col-xs-12">
              <div className="inner-box wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="0ms">
                <div className="image">
                  <img src="assets/images/chef-pramila-profile.jpg" alt="tiffin box delivery Coimbatore" />
                  <div className="overlay-box"></div>
                </div>
                <h5><a href="#">Pramila</a></h5>
                <div className="designation">Chef de Cuisine (aka Amma, Mummy, or "Please taste this")</div>
                <div className="text desc">
                  The heartbeat of the kitchen. Pramila doesn’t use timers or measuring cups—she uses memory,
                  mood, and the smell of the tadka. She's been cooking for over four decades, and still tastes
                  every batch of sambar like it’s her first.<br />
                  She’s the one who wakes up before sunrise to soak the dal “properly,” insists on grinding
                  coconut fresh (not from the fridge!), and tells the others, "Don't stand there. Do something useful."
                  She may seem strict, but her food hugs you before you even take the first bite.<br />
                  If your lunch had that “just made by someone who loves you” feel—it was her.
                  Most likely to say: “This is not the rasam I taught you to make.”
                </div>
              </div>
            </div>

            {/* Team Member */}
            <div className="team-block col-lg-4 col-md-6 col-sm-6 col-xs-12">
              <div className="inner-box wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="300ms">
                <div className="image">
                  <img src="assets/images/chef-ankita-profile.jpg" alt="homemade lunch for office" />
                  <div className="overlay-box"></div>
                </div>
                <h5><a href="#">Ankita</a></h5>
                <div className="designation">
                  Sous Chef (also Daughter-in-Law, Spreadsheet Whisperer, and Pramila Translator)
                </div>
                <div className="text desc">
                  Ankita married into the madness—and stayed for the masala. She brings balance to the kitchen:
                  where Amma is fire, Ankita is flame control. She convinced the family that customers do want
                  air-fried snacks, introduced menu labels (finally), and once got Amma to agree to use a digital
                  weighing scale (briefly).<br />
                  She manages pre-orders, keeps track of spice preferences, and knows exactly which regular
                  doesn’t like coriander. She also handles all Instagram posts, carefully cropping out oil stains
                  from the stove.<br />
                  Behind every customized meal, there’s Ankita tweaking, testing, and softly whispering to Amma,
                  “Let me handle this one, please.” Most likely to say: “She said low oil, Amma—not no taste!”
                </div>
              </div>
            </div>

            {/* Team Member */}
            <div className="team-block col-lg-4 col-md-6 col-sm-6 col-xs-12">
              <div className="inner-box wow fadeInUp" data-wow-duration="1500ms" data-wow-delay="600ms">
                <div className="image">
                  <img src="assets/images/manager-pawan-profile.jpg" alt="daily lunch delivery Coimbatore" />
                  <div className="overlay-box"></div>
                </div>
                <h5><a href="menu-list-1">Pawan</a></h5>
                <div className="designation">
                  Kitchen Manager (also Son, Husband, and Self-Appointed CEO of ‘Where’s My Order?’)
                </div>
                <div className="text desc">
                  Pawan doesn’t cook, but somehow he’s always in the kitchen—usually holding his phone,
                  answering five people at once, and dodging Amma’s ladle. He’s the one who remembers if a
                  customer’s kid likes extra pickle, or if the train delivery goes to platform 3 or 4.<br />
                  He mediates every culinary disagreement (there are many), manages logistics, packs meals,
                  and still gets blamed when the rice is undercooked—even if he wasn’t home.<br />
                  He’s the reason your dabba gets delivered warm and right on time, and the reason Amma didn’t
                  throw the mixer out (yet). Most likely to say: “I’m not shouting. I’m just saying it loudly.”
                </div>
              </div>
            </div>
          </div>

          <div style={{ textAlign: "center" }}>
            <h3 className="theme_color">Together...</h3><br />
            <p>
              They fight over salt levels, argue about whether this much ghee is “too much” or “just enough,” and
              occasionally threaten to shut everything down—right before laughing and cooking the next meal
              together.<br />
              Tickling Tummy isn’t perfect. But it’s full of soul, small joys, and second helpings. It's not just
              a kitchen—it’s a kitchen with opinions, heart, and humor. And that’s the team cooking for you.
            </p>
          </div>
        </div>
      </section>

      {/* Chef / Offers Section */}
      <section className="chef-section-1 section-kt">
        <div className="auto-container">
          <div className="row clearfix">
            {/* Text Block */}
            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
              <div className="title-box">
                <div className="subtitle"><span>What we Offers</span></div>
                <h4>Over time, we’ve grown into more than just “daily meals.” Today, we offer</h4><br />
                <p>
                  Custom pre-order cooking<br />
                  Meal subscriptions for busy people<br />
                  Catering for events<br />
                  Train meal delivery at Coimbatore Junction<br />
                  Homemade gifting hampers<br />
                  And our favorite—The Second Dabba, a slow Sunday lunch at our own table<br />
                </p>
                <p>
                  But at our core, we haven’t changed. We’re still that home that cooks a little extra,
                  just in case someone’s hungry.<br />
                  If you’ve ever missed a home-cooked meal, or wished your food came with a little more heart—you’re exactly
                  who we’ve been cooking for.
                </p>
              </div>
            </div>

            {/* Chef Images */}
            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
              <div className="chef-image image1 parallax-scene-2">
                <img data-depth="0.15" src="assets/images/head-chef-cooking.jpg" alt="corporate lunch service Coimbatore" />
              </div>
            </div>

            <div className="col-xl-4 col-lg-4 col-md-6 col-sm-12">
              <div className="chef-image image2 parallax-scene-3">
                <img data-depth="0.50" src="assets/images/chef-preparing-meal.jpg" alt="veg lunch box online" />
              </div>
              <div className="chef-image image3 parallax-scene-4">
                <img data-depth="0.50" src="assets/images/chef-serving-food.jpg" alt="packed lunch delivery Coimbatore" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>

  )
}

export default AboutOne
